import React from 'react';
import { TwoFAInfo } from './2FAInfo';

export default {
  messageId: 'two-fa-enablement-user',
  bannerTag: 'ACCOUNT_SEC_WARNING',
  descriptionComponent: (props) => (
    <TwoFAInfo
      {...props}
      linkTranslationId={{ base: 'ACCOUNT_SEC_LINK_DESCRIPTION_USER' }}
      descriptionTranslationId={'ACCOUNT_SEC_DESCRIPTION_USER'}
      linkHref={
        'https://www.qualtrics.com/support/survey-platform/managing-your-account/creating-account-logging/#LoggingintoYourAccount'
      }
      openInTheNewTab={true}
    />
  ),
  type: 'account',
  additionalAttributes: [
    {
      name: 'endDate',
      requireTranslate: false,
    },
  ],
};
